import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { availableDeliveryForInvoice, CreateInvoiceRequest, LoadInvoice, SearchAvailableDeliveriesForInvoiceRequest } from "src/app/domain/models/LoadInvoice";
import { PageResult } from "src/app/domain/models/PageResult";

@Injectable({providedIn: 'root'})
export abstract class LoadInvoiceGateway {
 abstract getAvailableDeliveriesForInvoice(request: SearchAvailableDeliveriesForInvoiceRequest):
  Observable<PageResult<availableDeliveryForInvoice>>;
  abstract createInvoice(request: CreateInvoiceRequest): Observable<any>;
  abstract getAllInvoicesByReference(referenceId: number, byProfile: boolean, pageNumber: number, pageSize: number): Observable<PageResult<LoadInvoice>>;
  abstract deleteInvoice(invoiceId: number): Observable<any>;
  abstract downloadInvoiceExcel(invoiceId: number): Observable<Blob>;
}
